import React, { Component, useState, useEffect, useRef } from "react";
import "../../SignIn/SignIn.scss";
import "./UserDetails.scss";
import LoginSignUp from "../../../hoc/LoginSignUp/LoginSignUp";
import {
  Field,
  FormBuilder,
  Validators,
  FieldGroup,
  FieldControl,
} from "react-reactive-form";
import { pattern } from "../../../services/subscriberService";
import {
  FormGroups,
  FormGroupRow,
} from "../../../components/ReusableComponents/FormGroups/FormGroups";
import {
  TextInput,
  CustomDate,
  CustomSelectBox,
} from "../../../components/UI/FormInput/FormInput";
import {
  UniqueID,
  CheckImageType,
  formatBytes,
} from "../../../services/CommonFunction";
import MemberProfileUpload from "../../../components/ReusableComponents/MemberProfileUpload/MemberProfileUpload";
import {
  ClosePopup,
  ErrorListUI,
  ErrorUI,
} from "../../../components/UI/Modals/Modals";
import { imgUpload } from "../../../services/CommonFormFunction";
import { updateProfile } from "../../../services/CallApi";
import store from "../../../store";
import moment from "moment";

export const gender = [
    { name: "Male", value: "MALE" },
    { name: "Female", value: "FEMALE" },
    { name: "Other", value: "OTHER" },
  ],
  height = [
    { name: "ft", value: "Feet" },
    { name: "cm", value: "CMs" },
  ],
  weight = [
    { name: "lbs", value: "Pounds" },
    { name: "kg", value: "Kg" },
  ];

const UserDetails = ({ userDetail, submitData, ...props }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userDetail.valid) {
      console.log(userDetail.value);
      ErrorUI(
        "The entered value for weight will impact your calorie calculation. Click Ok to proceed or cancel to change the value.",
        ClosePopup,
        {
          close: submitData,
          cancelText: "Ok",
          cancelClass: "btns-primary",
          submitClass: "btns-default",
          submitText: "Cancel",
        }
      );
    } else {
      let text = [];
      Object.keys(userDetail.controls).forEach((el) => {
        if (userDetail.get(el).invalid) {
          text.push(userDetail.get(el).meta.label);
          userDetail.get(el).markAsTouched({ emitEvent: true });
          userDetail.markAsTouched({ emitEvent: true });
        }
      });
      ErrorListUI("Please fill the following fields to continue", null, {
        arymsgs: text,
      });
    }
  };

  return (
    <div className="formDetailContainer">
      <FieldGroup
        control={userDetail}
        render={({ get }) => (
          <form onSubmit={handleSubmit}>
            <FieldGroup
              control={get("profile_pic")}
              meta={{ label: "Profile Picture" }}
              render={({ get, touched }) => (
                <MemberProfileUpload
                  image={get("image").value}
                  name={null}
                  showError={touched && get("value").hasError("required")}
                >
                  <input
                    type="file"
                    onChange={(e) => imgUpload(e, userDetail, "profile_pic")}
                    accept="image/heic,image/*"
                  />
                </MemberProfileUpload>
              )}
            />
            <FormGroupRow>
              <FormGroups>
                <FieldControl
                  name="first_name"
                  render={TextInput}
                  meta={{
                    label: "First Name",
                    showLabel: false,
                    type: "text",
                    placeholder: "First Name",
                    placeHolderIcon: "dropdownProfile",
                    valid: true,
                    showError: true,
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="last_name"
                  render={TextInput}
                  meta={{
                    label: "Last Name",
                    showLabel: false,
                    type: "text",
                    placeholder: "Last Name",
                    placeHolderIcon: "dropdownProfile",
                    valid: true,
                    showError: true,
                  }}
                />
              </FormGroups>
            </FormGroupRow>
            <FormGroups>
              <FieldControl
                name="email"
                render={TextInput}
                meta={{
                  label: "Email address",
                  showLabel: false,
                  type: "email",
                  placeholder: "Email address",
                  placeHolderIcon: "emailInput",
                  valid: true,
                  showError: true,
                }}
              />
            </FormGroups>
            <FormGroupRow>
              <FormGroups>
                <FieldControl
                  name="dob"
                  meta={{ label: "DOB" }}
                  render={({
                    handler,
                    touched,
                    hasError,
                    valid,
                    validator,
                    errors,
                    ...props
                  }) => {
                    const { onChange, value } = handler();
                    return (
                      <CustomDate
                        label=""
                        date={value}
                        maxDate={new Date(moment().subtract(16, "years"))}
                        handler={(el, status) => onChange(el)}
                        stateKey="dob"
                        showError={touched && hasError("required")}
                        valid={valid}
                      />
                    );
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="gender"
                  render={CustomSelectBox}
                  meta={{
                    formKey: "gender",
                    optionList: gender,
                    showLabel: false,
                    label: "Gender",
                    placeholder: "",
                    validation: true,
                  }}
                />
              </FormGroups>
            </FormGroupRow>
            <div className="userDetailFeildRow">
              <div
                className={`userDetailSubFeildRow${
                  get("height_value").touched &&
                  get("height_value").hasError("required")
                    ? " inputError"
                    : ""
                }`}
              >
                <FormGroups>
                  <FieldControl
                    name="height_value"
                    render={TextInput}
                    meta={{
                      label: "Height",
                      showLabel: false,
                      type: "number",
                      maxLength: "4",
                      placeholder: "Height",
                      placeHolderIcon: "",
                      valid: true,
                      showError: false,
                    }}
                  />
                </FormGroups>
                <FormGroups>
                  <FieldControl
                    name="height_unit"
                    render={CustomSelectBox}
                    meta={{
                      formKey: "height_unit",
                      optionList: height,
                      label: "",
                      placeholder: "",
                      validation: true,
                    }}
                  />
                </FormGroups>
              </div>
              <div
                className={`userDetailSubFeildRow${
                  get("weight_value").touched &&
                  get("weight_value").hasError("required")
                    ? " inputError"
                    : ""
                }`}
              >
                <FormGroups>
                  <FieldControl
                    name="weight_value"
                    render={TextInput}
                    meta={{
                      label: "Weight",
                      showLabel: false,
                      type: "text",
                      maxLength: "4",
                      placeholder: "Weight",
                      placeHolderIcon: "",
                      valid: true,
                      showError: false,
                    }}
                  />
                </FormGroups>
                <FormGroups>
                  <FieldControl
                    name="weight_unit"
                    render={CustomSelectBox}
                    meta={{
                      formKey: "weight_unit",
                      optionList: weight,
                      label: "",
                      placeholder: "",
                      validation: true,
                    }}
                  />
                </FormGroups>
              </div>
            </div>
            <div className="submitDiv" style={{ justifyContent: "center" }}>
              {/* <button className={`${invalid ? "disabled" : "enabled"}`} type="submit"><p>Continue</p></button> */}
              <button className={`enabled`} type="submit">
                <p>Continue</p>
              </button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default UserDetails;
